import React from 'react';
import { Box, Fade } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useReportContext } from 'contexts/report/ReportContext';
import { isSuccessState } from 'globals/utils';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { useReportAccountContext } from 'contexts/report/ReportAccountContext';
import SingleAccountItem from './SingleAccountItem';

const AccountDetailsSection: React.FC = () => {
  const {
    report: {
      bankAccountsList: { status, getActiveAccounts },
    },
  } = useReportContext();
  const { activeAccountId } = useReportAccountContext();
  const selectedAccounts = getActiveAccounts(activeAccountId);

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
        withShadow={false}
      />
    );
  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <Box data-test="account-details-section" mb={2}>
        {selectedAccounts.map(
          ({
            id,
            income,
            balance,
            expenditure,
            maturity,
            opening,
            ...props
          }) => (
            <SingleAccountItem
              {...props}
              key={id}
              id={id}
              income={income}
              balance={balance}
              expenditure={expenditure}
              maturity={maturity}
              opening={opening}
            />
          )
        )}
      </Box>
    </Fade>
  );
};

export default observer(AccountDetailsSection);
